interface PriceDisplayProps {
  price: number
  /** When set, the plan is billed annually — show the full yearly total below the per-month price. */
  annualTotal?: number
}

// Calculate the "pre-discount" price (40% off sale means current price is 60% of original)
function getPreDiscountPrice(price: number): number {
  // Round to nearest whole number for cleaner display
  return Math.round(price / 0.6)
}

// Whole dollars render without decimals; anything else keeps cents (e.g. 287.88).
function formatPrice(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(2)
}

export function PriceDisplay({ price, annualTotal }: PriceDisplayProps) {
  const preDiscountPrice = getPreDiscountPrice(price)

  return (
    <div>
      <div className="flex flex-wrap items-baseline gap-x-2">
        <span className="text-[#666] line-through text-base sm:text-lg">${preDiscountPrice}</span>
        <span className="text-3xl sm:text-4xl font-bold text-white">${formatPrice(price)}</span>
        <span className="text-[#666]">/month</span>
      </div>
      {annualTotal != null && (
        <p className="mt-1 text-xs text-[#888]">
          <span className="text-[#aaa] font-medium">${formatPrice(annualTotal)}</span> billed annually
        </p>
      )}
    </div>
  )
}
